import {ACCESS_TOKEN, V1_API_URL_PREFIX} from '../Constants';
import {request} from "./ApiUtils";

export function msds() {
    return request({
        url: V1_API_URL_PREFIX + "/msds",
        method: 'GET'
    });
}

export function saveOrUpdateMsds(record) {
    return request({
        url: V1_API_URL_PREFIX + "/msds/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function deleteMsds(record) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/msds/delete",
        method: 'DELETE',
        body: JSON.stringify(record)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function msdsRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/msds/latestRevision",
        method: 'GET'
    });
}

export function addMsdsRevision(review) {
    return request({
        url: V1_API_URL_PREFIX + "/msds/add/revision",
        method: 'POST',
        body: JSON.stringify(review)
    });
}